enum Roles {
    TICDI_ADMIN = "ticdi_admin"
}

export default Roles;